<!-- 离散制造解决方案模块 -->

<template>
  <div class="disperse_solution_box">
    <div
      class="dis_solution_content"
      :class="{
        'dis_solution_en lh-1 text-center': $i18n.locale === 'en_US','dis_solution_ja': $i18n.locale === 'ja_JP'
      }"
    >
      <div class="sheets_box">
        <div
          class="sheet_content text-center"
          :style="{
            'background-image': 'url(' + bgData + ')',
            backgroundSize: '100% 100%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
          }"
        >
          <!-- 标题行 -->
          <div
            class="text_title d-flex text-center"
            style="
              position: absolute;
              top: 1.5rem;
              left: 13.5rem;
              display: flex;
              width: 80%;
            "
          >
            <div class="title_center">
              {{ $t("solution.disperse.solutions.image.tab02.title") }}
            </div>
            <div class="title_center">
              {{ $t("solution.disperse.solutions.image.tab03.title") }}
            </div>
            <div class="title_center">
              {{ $t("solution.disperse.solutions.image.tab04.title") }}
            </div>
            <div class="title_center">
              {{ $t("solution.disperse.solutions.image.tab05.title") }}
            </div>
            <div class="title_center">
              {{ $t("solution.disperse.solutions.image.tab06.title") }}
            </div>
            <div class="title_center">
              {{ $t("solution.disperse.solutions.image.tab07.title") }}
            </div>
            <div class="title_center">
              {{ $t("solution.disperse.solutions.image.tab08.title") }}
            </div>
          </div>
          <!-- 第一列 -->
          <div class="text_normal" style="top: 44.5%; left: 0.2%; height: 85px">
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab01.description01") }}
            </div>
            <div class="tab_border tab_border_1_ja">
              {{ $t("solution.disperse.solutions.image.tab01.description02") }}
            </div>
          </div>
          <!-- 第二列 -->
          <div
            class="text_normal"
            style="top: 36.9%; left: 11.4%; height: 202px"
          >
            <div class="tab_border" style="color: #93b26d">
              {{ $t("solution.disperse.solutions.image.tab02.description01") }}
            </div>
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab02.description02") }}
            </div>
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab02.description03") }}
            </div>
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab02.description04") }}
            </div>
          </div>
          <!-- 第三列 -->
          <div class="text_normal" style="top: 22.3%; left: 23%; height: 255px">
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab03.description01") }}
            </div>
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab03.description02") }}
            </div>
            <div class="tab_border" style="color: #979c5e">
              {{ $t("solution.disperse.solutions.image.tab03.description03") }}
            </div>
            <div class="tab_border" style="color: #979c5e">
              {{ $t("solution.disperse.solutions.image.tab03.description04") }}
            </div>
            <div class="tab_border" style="color: #979c5e">
              {{ $t("solution.disperse.solutions.image.tab03.description05") }}
            </div>
          </div>
          <!-- 第四列 -->
          <div class="text_normal" style="top: 30%; left: 34.3%; height: 255px">
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab04.description01") }}
            </div>
            <div class="tab_border mt_dec--8">
              {{ $t("solution.disperse.solutions.image.tab04.description02") }}
            </div>
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab04.description03") }}
            </div>
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab04.description04") }}
            </div>
            <div class="tab_border tab_border_2_ja">
              {{ $t("solution.disperse.solutions.image.tab04.description05") }}
            </div>
          </div>
          <!-- 第五列 -->
          <div class="text_normal text_column text_column_en text_column_ja">
            <div class="">
              {{
                $t("solution.disperse.solutions.image.tab05.description01_1")
              }}
            </div>
            <div class="">
              {{
                $t("solution.disperse.solutions.image.tab05.description01_2")
              }}
            </div>
            <div class="">
              {{
                $t("solution.disperse.solutions.image.tab05.description01_3")
              }}
            </div>
            <div class="">
              {{
                $t("solution.disperse.solutions.image.tab05.description01_4")
              }}
            </div>
            <div class="">
              {{
                $t("solution.disperse.solutions.image.tab05.description01_5")
              }}
            </div>
            <div class="">
              {{
                $t("solution.disperse.solutions.image.tab05.description01_6")
              }}
            </div>
          </div>
          <div
            class="text_normal"
            style="top: 22.3%; left: 45.8%; height: 430px"
          >
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab05.description01") }}
            </div>
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab05.description02") }}
            </div>
            <div class="tab_border mt_dec--4" >
              {{ $t("solution.disperse.solutions.image.tab05.description03") }}
            </div>
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab05.description04") }}
            </div>
            <div class="tab_border tab_border_2_ja">
              {{ $t("solution.disperse.solutions.image.tab05.description05") }}
            </div>
            <div class="tab_border" style="color: #cfb975">
              {{ $t("solution.disperse.solutions.image.tab05.description06") }}
            </div>
            <div class="tab_border" style="color: #cfb975">
              {{ $t("solution.disperse.solutions.image.tab05.description07") }}
            </div>
            <div class="tab_border" style="color: #cfb975">
              {{ $t("solution.disperse.solutions.image.tab05.description08") }}
            </div>
          </div>
          <!-- 第六列 -->
          <div class="text_normal" style="top: 30%; left: 57.1%; height: 487px">
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab06.description01") }}
            </div>
            <div class="tab_border" style="margin-top: -8px;">
              {{ $t("solution.disperse.solutions.image.tab06.description02") }}
            </div>
            <div class="tab_border" style="color: #d8a456">
              {{ $t("solution.disperse.solutions.image.tab06.description03") }}
            </div>
            <div class="tab_border" style="color: #d8a456">
              {{ $t("solution.disperse.solutions.image.tab06.description04") }}
            </div>
            <div class="tab_border" style="color: #d8a456">
              {{ $t("solution.disperse.solutions.image.tab06.description05") }}
            </div>
            <div class="tab_border" style="color: #d8a456">
              {{ $t("solution.disperse.solutions.image.tab06.description06") }}
            </div>
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab06.description07") }}
            </div>
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab06.description08") }}
            </div>
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab06.description09") }}
            </div>
          </div>
          <!-- 第七列 -->
          <div
            class="text_normal"
            style="top: 36.8%; left: 68.6%; height: 435px"
          >
            <div class="tab_border" style="color: #b4a73b">
              {{ $t("solution.disperse.solutions.image.tab07.description01") }}
            </div>
            <div class="tab_border" style="color: #b4a73b">
              {{ $t("solution.disperse.solutions.image.tab07.description02") }}
            </div>
            <div class="tab_border" style="color: #b4a73b">
              {{ $t("solution.disperse.solutions.image.tab07.description03") }}
            </div>
            <div class="tab_border" style="color: #b4a73b">
              {{ $t("solution.disperse.solutions.image.tab07.description04") }}
            </div>
            <div class="tab_border" style="color: #b4a73b">
              {{ $t("solution.disperse.solutions.image.tab07.description05") }}
            </div>
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab07.description06") }}
            </div>
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab07.description07") }}
            </div>
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab07.description08") }}
            </div>
          </div>
          <!-- 第八列 -->
          <div
            class="text_normal"
            style="top: 36.6%; left: 79.9%; height: 205px"
          >
            <div class="tab_border" style="color: #6cbb6f">
              {{ $t("solution.disperse.solutions.image.tab08.description01") }}
            </div>
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab08.description02") }}
            </div>
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab08.description03") }}
            </div>
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab08.description04") }}
            </div>
          </div>
          <!-- 第九列 -->
          <div class="text_normal" style="top: 44.4%; right: 0%; height: 88px">
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab09.description01") }}
            </div>
            <div class="tab_border">
              {{ $t("solution.disperse.solutions.image.tab09.description02") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="desc_box">
      {{ $t("solution.disperse.solutions.image.description") }}
    </div>
    <div class="summary_title_box">
      {{ $t("solution.disperse.solutions.tab.title") }}
    </div>
    <div class="summaryList_box">
      <div class="row">
        <div
          class="summary_item col-lg-4 col-md-6 col-sm-12 col-12 row p-3 p-lg-5 p-md-5"
        >
          <div class="item_icon_box">
            <img
              class="item_icon"
              :src="
                require('../../../../assets/images/IndustrySolution/disperseSolutions/icon_solution.png')
              "
              width="70px"
              height="70px"
            />
          </div>
          <div
            class="item_text_box"
            :style="{
              'background-image': 'url(' + itemBg1 + ')',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'bottom',
            }"
          >
            {{ $t("solution.disperse.solutions.tab.tab01") }}
          </div>
        </div>
        <div
          class="summary_item col-lg-4 col-md-6 col-sm-12 col-12 row p-3 p-lg-5 p-md-5"
        >
          <div class="item_icon_box">
            <img
              class="item_icon"
              :src="
                require('../../../../assets/images/IndustrySolution/disperseSolutions/icon_solution.png')
              "
              width="70px"
              height="70px"
            />
          </div>
          <div
            class="item_text_box"
            :style="{
              'background-image': 'url(' + itemBg2 + ')',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'bottom',
            }"
          >
            {{ $t("solution.disperse.solutions.tab.tab02") }}
          </div>
        </div>
        <div
          class="summary_item col-lg-4 col-md-6 col-sm-12 col-12 row p-3 p-lg-5 p-md-5"
        >
          <div class="item_icon_box">
            <img
              class="item_icon"
              :src="
                require('../../../../assets/images/IndustrySolution/disperseSolutions/icon_solution.png')
              "
              width="70px"
              height="70px"
            />
          </div>
          <div
            class="item_text_box"
            :style="{
              'background-image': 'url(' + itemBg3 + ')',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'bottom',
            }"
          >
            {{ $t("solution.disperse.solutions.tab.tab03") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DisperseSolutions',
  data () {
    return {
      bgData: require('../../../../assets/images/IndustrySolution/disperseSolutions/solution_sheet_bg.png'),
      itemBg1: require('../../../../assets/images/IndustrySolution/disperseSolutions/summary_item_bg1.png'),
      itemBg2: require('../../../../assets/images/IndustrySolution/disperseSolutions/summary_item_bg2.png'),
      itemBg3: require('../../../../assets/images/IndustrySolution/disperseSolutions/summary_item_bg3.png'),
    }

  }
}
</script>